import { useSelector } from 'react-redux';
import dynamicfunction from '../../utils/dynamicfunction';
import { getContentKeyAccToLang } from '../../utils/utils';

export default () => {
  const { isArabic, TextWeight } = dynamicfunction();

  const authContent = useSelector((state) => state.content?.authContent);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(authContent?.web_onboarding?.data?.attributes, key, isArabic);
  };

  return { isArabic, TextWeight, getContentKey };
};
